import { useMemo } from "react";

import { CliError, CliMatch } from "@types";
import { ERROR_TYPE_CODE, ERROR_TYPE_PATTERN } from "@utils";

import { RunResponse, SemgrepRunException } from "@pages/editor/types";

export interface RunResponseStructure {
  findings: CliMatch[];
  cliErrors: CliError[];
  patternErrors: CliError[];
  targetErrors: CliError[];
  fatalErrors: CliError[];
  runError?: SemgrepRunException;
  allErrors: (CliError | SemgrepRunException)[];
}

export const useRunResponse = (
  runResult: RunResponse
): RunResponseStructure => {
  const findings = runResult.semgrep_result.output.results;
  const cliErrors = runResult.semgrep_result.output.errors;
  const patternErrors = useMemo(
    () => cliErrors.filter((err) => err.type === ERROR_TYPE_PATTERN),
    [cliErrors]
  );
  const targetErrors = useMemo(
    () => cliErrors.filter((err) => err.type === ERROR_TYPE_CODE),
    [cliErrors]
  );
  const fatalErrors = useMemo(
    () =>
      cliErrors.filter(
        (err) => err.type !== ERROR_TYPE_CODE && err.type !== ERROR_TYPE_PATTERN
      ),
    [cliErrors]
  );
  const runError = runResult.semgrep_result.run_error;
  const allErrors = useMemo(() => {
    const errors: (CliError | SemgrepRunException)[] = [...cliErrors];
    if (!!runError) {
      errors.push(runError);
    }
    return errors;
  }, [cliErrors, runError]);
  return {
    findings,
    cliErrors,
    patternErrors,
    targetErrors,
    runError,
    fatalErrors,
    allErrors,
  };
};
